import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";
import { Loader, Typography, TandCModal } from "components";
import { setPersonalDetails } from "redux/actions/onboardingActions";
import { isAdminUser } from "utils/helper";

import {
  isSuccessResponse,
  formatDateTime,
  capitalizeFirstLetter,
  getGender,
  getIdentificationType,
} from "utils/helper";

const UserInfo = ({ agentId }) => {
  const [loading, setLoading] = useState(false);
  const [displayNoInfo, setDisplayNoInfo] = useState(false);
  const [openTandCModal, setOpenTandCModal] = useState(false);

  const {
    onBoardingInfo: { personalDetails },
    user: { user },
  } = useSelector((state) => state);

  const {
    dateOfBirth,
    phoneNumber,
    email,
    firstName,
    gender,
    lastName,
    aggregator,
    address,
    localGovt,
    region,
    state,
    nearestBusStop,
    identificationType,
    identificationNumber,
    corporate,
    corporateName,
    tin,
    bvn,
    acceptedTC,
    isPEP,
    pepDetails,
    referredBy,
    referralAgentCode,
    kyccomment,
    status,
  } = personalDetails || {};

  const renderDetails = [
    { label: "Phone Number", value: phoneNumber },
    { label: "First Name", value: capitalizeFirstLetter(firstName) },
    { label: "Last Name", value: capitalizeFirstLetter(lastName) },
    { label: "Gender", value: getGender(gender)?.label },
    { label: "Date Of Birth", value: formatDateTime(dateOfBirth) },
    { label: "Email", value: email },
    { label: "Address", value: address },
    { label: "State", value: state },
    { label: "Region", value: region },
    { label: "Local Government", value: localGovt },
    { label: "Nearest Bus stop", value: nearestBusStop },
    {
      label: "Identification Type",
      value: getIdentificationType(identificationType)?.label,
    },
    { label: "Identification Number", value: identificationNumber },
    { label: "User Type", value: aggregator ? "Aggregator" : "Agent" },
    { label: "Corporate Agent", value: corporate ? "Yes" : "No" },
    {
      label: `Is ${aggregator ? "Aggregator" : "Agent"} a/related to a PEP`,
      value: isPEP ? "Yes" : "No",
    },
    { label: "Additional PEP Details", value: pepDetails ? pepDetails : "Nil" },
    { label: "Referral Method", value: referredBy ? referredBy : "Nil" },

    { label: "BVN", value: bvn },
    { label: "Accepted T and C", value: acceptedTC ? "Yes" : "No" },
  ];

  if (referralAgentCode) {
    renderDetails.splice(renderDetails.length - 2, 0, {
      label: "Referral Aggregator Code",
      value: referralAgentCode,
    });
  }

  if (corporate && corporateName) {
    renderDetails.splice(renderDetails.length - 2, 0, {
      label: "Corporate Name",
      value: corporateName,
    });
  }

  useEffect(() => {
    const getAgentPersonalDetails = async () => {
      setLoading(true);
      try {
        const { data } = await makeRequest(
          "get",
          routes.getAgentPersonalDetails(`agentId=${agentId}`)
        );

        if (isSuccessResponse(data)) {
          if (data?.data?.content?.length) {
            const info = data?.data?.content[0];

            const { agentDetails, ...rest } = info;

            const newInfo = { ...agentDetails, ...rest };

            setPersonalDetails(newInfo);
          } else {
            setDisplayNoInfo(true);
          }
        }

        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    !personalDetails && getAgentPersonalDetails();
    //eslint-disable-next-line
  }, []);

  if (loading)
    return (
      <div className="d-flex justify-content-center onboarding-loader">
        <Loader />
      </div>
    );

  if (displayNoInfo)
    return (
      <Typography variant="subtitle3" className={"text-center mt-3"}>
        No Personal Information provided
      </Typography>
    );

  return (
    <div className="row user-detail-container">
      {renderDetails.map(({ label, value }, key) => (
        <div className="col-md-6 mt-3" key={key}>
          <Typography>
            {label}: &nbsp; &nbsp; {value}
          </Typography>
        </div>
      ))}
      {tin && corporate && (
        <div className="col-md-6 mt-3">
          <Typography>TIN: &nbsp; &nbsp; {tin}</Typography>
        </div>
      )}

      {isAdminUser(user) && kyccomment && status !== "KYC_VERIFIED" && (
        <div className="col-md-6 mt-3">
          <Typography>Rejection Comment: &nbsp; &nbsp; {kyccomment}</Typography>
        </div>
      )}

      {acceptedTC && (
        <Typography
          variant="body4"
          state="secondary"
          component="span"
          className={"cursor-pointer mt-4"}
          onClick={() => setOpenTandCModal(true)}
          // onClick={() => navigate(ROUTES.onBoardingTANDC)}
        >
          View Terms and Conditions accepted
        </Typography>
      )}

      <TandCModal
        showModal={openTandCModal}
        onClose={() => setOpenTandCModal(false)}
      />
    </div>
  );
};

export default UserInfo;
